import React, { Component } from 'react';
import StarRatingComponent from 'react-star-rating-component';
import MediaQuery from 'react-responsive';
import {
  Link,
} from 'react-router-dom';
import './UserQuery.css';
import AuthService from './AuthService';
import AuthModalContext from '../contexts/AuthModalContext';
import constants from '../config';

const Auth = new AuthService();

class UserQuery extends Component {
  static contextType = AuthModalContext;

  constructor(props) {
    super();
    this.state = {
      id: props.id,
      name: props.name,
      username: props.username,
      bio: props.bio,
      rating: props.rating,
      profilePic: props.profilePic,
      following: props.following,
    };
    this.handleFollow = this.handleFollow.bind(this);
  }

  handleFollow() {
    if (this.state.following === false) {
      Auth.fetch(`${constants.DOMAIN}/api/v1/users/${this.state.id}/follow`,{
        mode: 'cors',
        method: 'POST',
      }).then(res => {
        this.setState({
          following: res.profile.following,
        });
      })
        .catch(err => {
          console.log(err);
        });
    } else {
      Auth.fetch(`${constants.DOMAIN}/api/v1/users/${this.state.id}/unfollow`, {
        mode: 'cors',
        method: 'DELETE',
      }).then(res => {
        this.setState({
          following: res.profile.following,
        });
      })
        .catch(err => {
          console.log(err);
        });
    }
  }

  render() {
    // images front
    const api = `${constants.DOMAIN}/`;
    let button;

    if (Auth.getToken()) {
      const user = Auth.getProfile();
      if (user._id !== this.state.id) {
        button = this.state.following ? <button type="button" className="form-submit" onClick={this.handleFollow}>Following</button> : <button type="button" className="form-submit" onClick={this.handleFollow}>Follow</button>;
      } else {
        button = '';
      }
    } else {
      button = <button type="button" className="form-submit" onClick={() => this.context.openAuthModal('login')}><p>Follow</p></button>
    }

    return (
      <div className="UserQuery">
        <div className="col-md-12 col-sm-12 col-xs-12 userCard">
          <div className="col-md-3 col-sm-4 col-xs-4 UserQuery-impression">
            <Link to={'/shop/' + this.state.username}><img src={api + this.state.profilePic} alt="profilePic" /></Link>
            <MediaQuery query="(max-device-width: 640px)">
              {button}
            </MediaQuery>
            <MediaQuery query="(min-device-width: 641px)">
              <div style={{ paddingTop: '0px' }} className="stars">
                <StarRatingComponent
                  name="rating"
                  editing={false}
                  starCount={5}
                  starColor="#ffd788"
                  emptyStarColor="#939393"
                  value={this.state.rating}
                />
              </div>
            </MediaQuery>

          </div>
          <div className="col-md-9 col-sm-8 col-xs-8 UserQuery-heading">
            <div className="UserQuery-text">
              <Link to={'/shop/' + this.state.username}><h3><strong>{this.state.name}</strong></h3></Link>
              <Link to={'/shop/' + this.state.username}><h4 style={{ color: '#2155cf' }} >@{this.state.username}</h4></Link>
              <p>{this.state.bio}</p>
            </div>
            <MediaQuery query="(max-device-width: 640px)">
              <div style={{ paddingTop: '0px' }} className="stars">
                <StarRatingComponent
                  name="rating"
                  editing={false}
                  starCount={5}
                  starColor="#ffd788"
                  emptyStarColor="#939393"
                  value={this.state.rating}
                />
              </div>
            </MediaQuery>
            <MediaQuery query="(min-device-width: 641px)">
              {button}
            </MediaQuery>
          </div>
        </div>
      </div>
    );
  }
}

export default UserQuery;
